"use strict";
module.exports = process.env.npm_package_version;
